<template>
  <v-container fluid>
    <v-form ref="form" @submit.prevent="save(false)">
      <v-row>
        <form-header :title="isEditing ?'Modifica vendita' : 'Nuovo vendita'"
                     @back="$router.replace('/sells')" @saveback="save(true)" :loading="loading" ></form-header>
        <v-col cols="12" >
          <h3>Dettagli acquirente</h3>
        </v-col>
        <v-col cols="12" lg="6">
          <v-autocomplete label="Utente*" v-model="editingItem.user_id" :rules="[rules.required]" :items="userOptions" :hint="fiscalCode" persistent-hint @update:model-value="onUserSelected()">
            <template #item="{item, props}">
              <v-list-item v-bind="props" :subtitle="item.raw.fiscal_code"></v-list-item>
            </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" class="py-0"></v-col>
        <v-col cols="12" md="6" lg="4" xl="3" v-if="editingItem.expedition">
          <v-text-field
              label="Indirizzo"
              v-model="editingItem.address!.name"
              hint="Via\Piazza ..."
              :rules="[rules.required]"
              autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3" v-if="editingItem.expedition">
          <v-text-field
              label="Città"
              v-model="editingItem.address!.city"
              :rules="[rules.required]"
              autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3" v-if="editingItem.expedition">
          <v-text-field
              label="Provincia"
              hint="es. PG"
              v-model="editingItem.address!.province"
              :rules="[rules.required]"
              autocomplete="off"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3" v-if="editingItem.expedition">
          <v-text-field
              label="CAP"
              v-model="editingItem.address!.zip_code"
              :rules="[rules.required]"
              autocomplete="off"
          ></v-text-field>
        </v-col>

        <v-col cols="12" >
          <h3>Prodotti nell'ordine di acquisto</h3>
        </v-col>
        <v-col cols="12" lg="6">
          <v-table class="rounded border" density="compact" striped="even">
            <thead>
            <tr>
              <th>Pacchetto</th>
              <th>Prodotto</th>
              <th>Prezzo</th>
              <th style="width: 60px"></th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!editingItem.items || !editingItem.items.length">
              <td colspan="4" class="text-center font-italic">
                Al momento non ci sono prodotti nell'ordine.
              </td>
            </tr>
            <tr v-else v-for="(el, i) in editingItem.items" :key="`${el}_${i}`">
              <td>
                {{getKitName(el)}}
              </td>
              <td>
                {{getProductName(el)}}
              </td>
              <td>
                {{getProductPrice(el)}}
              </td>
              <td>
                <v-btn variant="text" icon="mdi-close" color="primary" @click="removeItem(i)"></v-btn>
              </td>
            </tr>
            </tbody>
          </v-table>
        </v-col>
        <v-col cols="12" lg="6">
          <v-row>
            <v-col cols="12" lg="6">
              <v-autocomplete label="Seleziona pacchetto" v-model="kitId" :items="kitOptions" @update:model-value="productId = undefined"></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="6">
              <v-autocomplete label="Seleziona prodotto" v-model="productId" :items="productOptions" :disabled="!kitId" append-icon="mdi-plus" @click:append="addItem()"></v-autocomplete>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field
              label="Numero di giorni di pausa extra"
              v-model="editingItem.sub_pause_days"
              type="number" step="1" min="0" max="20"
              :rules="[rules.minInt(0), maxSubRule]"
          ></v-text-field>
        </v-col>


        <v-col cols="12" >
          <h3>Dettagli ordine</h3>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-select label="Metodo di pagamento" :items="paymentMethods" v-model="editingItem.payment_method"></v-select>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-text-field label="ID di pagamento" v-model="editingItem.payment_uid" :rules="[rules.required]"></v-text-field>
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3">
          <v-select label="Stato ordine" :items="cartStatusOptions" v-model="editingItem.status"></v-select>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch label="Home Kit (in regalo o nell'ordine)" v-model="editingItem.home_kit"></v-switch>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch
              label="Richiesta tessera MSP (nuova o rinnovo)"
              :hint="`La tessera ha un costo di ${settings.coni_card_price}€`"
              persistent-hint v-model="editingItem.card"
          ></v-switch>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch label="Ordine evaso" v-model="editingItem.evaded"></v-switch>
        </v-col>

        <v-col cols="12" md="6" lg="4" xl="3">
          <v-switch label="Impediscine la modifica/cancellazione" v-model="editingItem.block_edit"></v-switch>
        </v-col>
        <form-footer @back="$router.replace('/sells')" @saveback="save(true)" :loading="loading"></form-footer>
      </v-row>
    </v-form>

    <v-dialog v-model="cardDialog" max-width="500">
      <v-card>
        <v-card-title>Tessera MSP scaduta</v-card-title>
        <v-card-text>
          <p>La tessera MSP di questo utente è scaduta, vuoi aggiungere il rinnovo della tessera al carrello?<br>La tessera ha un costo di {{settings.coni_card_price}}€</p>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn @click="cardDialog = false;">No</v-btn>
          <v-btn variant="elevated" color="primary" @click="addConiCardToCart()">Sì</v-btn>

        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script lang="ts">
import utils from "../utils";
import rules from "../utils/rules";
import FormHeader from "@/components/FormHeader.vue";
import FormFooter from "@/components/FormFooter.vue";
import {computed, inject, onMounted, ref, useTemplateRef} from "vue";
import type {Auth} from "@/plugins/auth.ts";
import {type Messages, Msg} from "@/plugins/messages.ts";
import type {Globals} from "@/plugins/globals.ts";
import {useRoute, useRouter} from "vue-router";
import api from "@/api";
import {VForm} from "vuetify/components";
import type {Cart, Purchase} from "@/models.ts";
import {DateTime} from "luxon";
import {cartStatusOptions, paymentMethods} from "@/consts.ts";
export default {
  components: {FormFooter, FormHeader},
  setup() {
    const auth = inject('auth') as Auth
    const messages = inject('messages') as Messages
    const globals = inject('globals') as Globals
    const route = useRoute()
    const router = useRouter()
    const form = useTemplateRef<typeof VForm>('form')
    const loading = ref(false)
    const cardDialog = ref(false)
    const kitId = ref<string|undefined>()
    const productId = ref<string|undefined>()

    const editingItem = ref<Cart>({
      block_edit: false,
      card: false,
      evaded: false,
      expedition: false,
      home_kit: false,
      items: [],
      payment_method: "",
      payment_uid: "",
      paypal_detail: "",
      paypal_request_id: "",
      paypal_status: "",
      status: "",
      sub_pause_days: 0,
      user_id: "",
      address : {name:'', city:'', province:'', zip_code:''}
    })

    const userPurchases = ref<Purchase[]>([])

    const loadData = async () => {
      loading.value = true;
      let id = route.params.id as string;
      const res = await api.get<Cart>('carts', id)
      if(!res.success) {
        loading.value = false;
        messages.error(res.message ?? Msg.serverError)
        await router.replace('/sells')
        return
      }
      if(!res.data!.items) res.data!.items = []
      editingItem.value = res.data!
      loading.value = false;
    }

    const subPauseExtraAvailable = computed(()=>{
      const user = globals.users.value.find(i => i._id === editingItem.value.user_id)
      if(!user) return 0
      const now = DateTime.now()
      const pauses = globals.pauses.value.filter(p => {
        if(p.user_id !== user._id) return false;
        const from = DateTime.fromISO(p.from)
        const to = DateTime.fromISO(p.to)
        return now > from && now < to
      })
      let num = 0;
      for(let i = 0; i < pauses.length; i++) {
        const p = pauses[i]
        num+=p.num_days;
      }

      return Math.max(0, globals.settings.value.extra_day_of_sub_pause_price - num);
    })

    const refreshPurchases = async ()=>{
      const res = await api.list<Purchase>('purchases', { user: editingItem.value.user_id}, 0, 0)
      userPurchases.value = res.data ?? [];
    }

    onMounted(async ()=>{
      await globals.waitForInit
      await router.isReady()
      await Promise.all([
          globals.refreshEmpty('users'),
          globals.refreshEmpty('kits'),
          globals.refreshEmpty('products'),
          globals.refreshEmpty('pauses'),
          globals.refreshEmpty('cards'),
      ])
      if (route.params.id !== "new") {
        await loadData();
        await refreshPurchases();
      }
    })




    return {
      form,
      cardDialog,
      loading,
      isEditing : computed(()=> route.params.id !== "new"),
      editingItem,
      kitId,
      productId,
      settings : globals.settings,
      maxSubRule: (value:string|undefined) => {
        if (value) {
          const val = utils.toInt(value, subPauseExtraAvailable.value + 1);
          if (val > subPauseExtraAvailable.value) return `deve essere un numero intero minore o uguale a ${subPauseExtraAvailable.value}`;
        }
        return true;
      },

      kitOptions : computed(()=>{
        let items= globals.kits.value.filter(i => i.pub)

        items.sort((a, b) => {
          if(a.category.is_gym_category && !b.category.is_gym_category) return -1
          if(!a.category.is_gym_category && b.category.is_gym_category) return 1
          if(a.order < b.order) return -1
          if(a.order > b.order) return 1
          return 0
        })
        return items.map(i => {
          return { title : i.title.it + ` (${i.order})`, value : i._id}
        })
      }),
      productOptions : computed(()=>{
        if(!kitId.value) return []
        return globals.products.value.filter(i => {
          if(i.kit_id !== kitId.value) return false;
          if(editingItem.value.items.includes(i._id!)) return false;
          if(!i.is_seats_product) {
            if(userPurchases.value.map(p => p.product_id).includes(i._id!)) return false
          }
          return true
        }).map(i => {
          return { title : `${i.title.it}(${i.sku})`, value : i._id}
        })
      }),
      rules,
      formatDate : utils.formatDate,
      userOptions : computed(()=>{
        return globals.users.value.map(i => {
          return { title : i.name + ' ' + i.surname, value : i._id, fiscal_code : i.fiscal_code }
        })
      }),
      fiscalCode : computed(()=>{
        if(!editingItem.value.user_id) return undefined
        const user = globals.users.value.find(i => editingItem.value.user_id === i._id)
        if(!user) return undefined
        return user.fiscal_code
      }),
      getKitName(productId:string) {
        const product = globals.products.value.find(i => i._id === productId)
        if(!product) return '-'
        const kit = globals.kits.value.find(i => i._id === product.kit_id)
        return kit?.title?.it ?? '-'
      },
      getProductName(productId:string) {
        const product = globals.products.value.find(i => i._id === productId)
        return product?.title?.it ?? '-'
      },
      getProductPrice(productId:string) {
        const product = globals.products.value.find(i => i._id === productId)
        return product ? `€${product.price.toFixed(2)}` : '-'
      },
      addItem() {
        if(!productId.value) return
        const p = globals.products.value.find(i => i._id === productId.value)
        if(!p) return;
        if(p.expedition) {
          editingItem.value.expedition = p.expedition
        }
        editingItem.value.items.push(productId.value)
        productId.value = undefined
      },
      removeItem(i:number) {
        messages.requestConfirm("Richiesta conferma", "Sei sicuro di vole eliminare questo prodotto dall'ordine?", false, ok => {
          if(ok) editingItem.value.items.splice(i,1)
          editingItem.value.expedition = false
          for(let i = 0; i < editingItem.value.items.length; i++) {
            const p = globals.products.value.find(p => p._id === editingItem.value.items[i]);
            if(p && p.expedition) {
              editingItem.value.expedition = true
            }
          }
          if(editingItem.value.status === 'expedition' || editingItem.value.status === 'paid') {
            editingItem.value.status = 'closed'
          }
        })
      },
      async onUserSelected() {
        editingItem.value.card = false
        await refreshPurchases();
        const cards = globals.cards.value.filter(c => {
          if(c.user_id !== editingItem.value.user_id) return false
          const dt = DateTime.fromISO(c.expiration)
          return dt.isValid && dt > DateTime.now()
        })
        if(!cards.length) {
          cardDialog.value = true
        }
      },
      addConiCardToCart() {
        editingItem.value.card = true
        cardDialog.value = false
      },
      paymentMethods,
      cartStatusOptions,
      async save(goBackAfterSave:boolean) {
        if(!editingItem.value.expedition) editingItem.value.address = undefined
        const v = await form.value!.validate()
        if(!v.valid) return;
        loading.value = true;
        const res = await api.save<Cart>('carts', editingItem.value)
        loading.value = false;
        if(!res.success) {
          messages.error(res.message ?? Msg.serverError)
          if(res.status === 401) {
            auth.logout()
          }
          return
        }
        editingItem.value = res.data!
        messages.success("vendita salvata")
        if(goBackAfterSave) {
          await router.replace('/sells')
        } else if(route.params.id === 'new'){
          await router.replace(`/sells/${editingItem.value._id}`)
        }
      }
    };
  }
};
</script>

<style scoped></style>
